import { create } from 'zustand';

const logoutController = (_: any) => ({
  logout: () => {
    localStorage.clear();
    window.location.href = '/login';
  },
});

export default create(logoutController);
